import { render, staticRenderFns } from "./AssetsTrendLineChart.vue?vue&type=template&id=2724c552&"
import script from "./AssetsTrendLineChart.vue?vue&type=script&lang=js&"
export * from "./AssetsTrendLineChart.vue?vue&type=script&lang=js&"
import style0 from "./AssetsTrendLineChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/_vuetify-loader@1.7.2@vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
